<template>
  <div class="acc-auth-cla">
    <div class="left-part-cla">
      <div style="margin-bottom:10px">
        <el-input
          :placeholder="$t('common.inputKeyWord')"
          v-model="search.value"
          class="input-with-select"
        >
          <el-select
            style="width:100px"
            v-model="search.key"
            slot="prepend"
            :placeholder="$t('common.select')"
          >
            <el-option :label="$t('device.sn')" value="sn"></el-option>
            <el-option
              :label="$t('accManager.doorName')"
              value="doorName"
            ></el-option>
          </el-select>
          <el-button
            @click="getDeviceList"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </div>
      <el-table
        ref="doorListTable"
        class="door-table-cla"
        :stripe="true"
        :highlight-current-row="true"
        :data="doorList"
        @row-click="rowClick"
      >
        <el-table-column
          prop="doorName"
          :label="$t('accManager.doorName')"
        ></el-table-column>
        <el-table-column prop="devName" :label="$t('accManager.devAlias')">
          <template slot-scope="scope">
            {{ scope.row.devName }}/{{ scope.row.devSn }}
          </template>
        </el-table-column>
        <el-table-column prop="devStatus" :label="$t('accManager.devStatus')">
          <template slot-scope="scope">
            <span
              class="doorDevice-online-cla"
              v-if="scope.row.devStatus === '1'"
              >{{ $t('device.online') }}</span
            >
            <span class="doorDevice-offline-cla" v-else>{{
              $t('device.offLine')
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="right-part-cla">
      <div class="enpty-info-cla" v-if="infoList.length === 0">
        <div v-if="currentRow === null">
          暂无数据，请点击右侧设备列表
        </div>
        <div v-else>
          暂无数据
        </div>
      </div>
      <el-collapse v-else v-model="activeName" accordion>
        <el-collapse-item
          v-for="item of infoList"
          :key="item.accLevel.id"
          name="1"
        >
          <template slot="title">
            <div class="collapse-title">
              {{
                item.accLevel.name +
                  '[ ' +
                  item.accLevel.startTime +
                  '~' +
                  item.accLevel.endTime +
                  ']'
              }}
            </div>
          </template>
          <div :key="timezone.id" v-for="timezone of item.accTimezoneList">
            <div class="time-bar-box">
              <label class="time-bar-label">{{
                getWeekDay(timezone.week)
              }}</label>
              <div class="time-bar">
                <span class="start-tip">00:00</span>
                <span class="end-tip">23:59</span>
                <div
                  :style="
                    barStyle(
                      rendTime(timezone.startTime),
                      rendTime(timezone.endTime)
                    )
                  "
                  class="active-time-bar"
                >
                  <div class="active-time-tip">
                    <span>{{ timezone.startTime }}</span>
                    <span>~</span>
                    <span>{{ timezone.endTime }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import {
  findAccAuthorityDevice,
  findUserBindDeviceLevel
} from '@/services/accManager.js'
export default {
  data() {
    return {
      search: {
        key: 'sn',
        value: ''
      },
      doorList: [],
      currentRow: null,
      infoList: []
    }
  },
  props: {
    employeeId: {
      type: '',
      default: ''
    }
  },
  watch: {
    employeeId(newValue) {
      if (newValue) {
        this.getDeviceList()
      }
    }
  },
  mounted() {
    this.getDeviceList()
  },
  methods: {
    getWeekDay(myddy) {
      var weekday = [
        this.$t('common.sunday'),
        this.$t('common.monday'),
        this.$t('common.tuesday'),
        this.$t('common.wednesday'),
        this.$t('common.thursday'),
        this.$t('common.friday'),
        this.$t('common.saturday'),
        this.$t('accManager.holiday1'),
        this.$t('accManager.holiday2'),
        this.$t('accManager.holiday3')
      ]
      return weekday[myddy]
    },
    barStyle(startTime, endTime) {
      let result = (endTime - startTime) / 1439
      return {
        width: result * 100 + '%',
        left: (startTime / 1439) * 100 + '%'
      }
    },
    rendTime(timeStr) {
      let timeArray = timeStr.split(':')
      let hourStr = timeArray[0]
      let minuteStr = timeArray[1]
      let hour = 0
      let minute = 0
      if (hourStr.startsWith('0')) {
        let tempStr = hourStr.charAt(1)
        hour = parseInt(tempStr)
      } else {
        hour = parseInt(hourStr)
      }
      if (minuteStr.startsWith('0')) {
        let tempStr = minuteStr.charAt(1)
        minute = parseInt(tempStr)
      } else {
        minute = parseInt(minuteStr)
      }
      return hour * 60 + minute
    },
    rowClick(row) {
      this.currentRow = row
      findUserBindDeviceLevel({
        employeeId: this.employeeId,
        sn: row.devSn,
        doorId: row.doorId
      }).then(data => {
        this.infoList = data.payload.results
      })
    },

    getDeviceList() {
      if (!this.employeeId) {
        return false
      }
      let params = {
        employeeId: this.employeeId
      }

      if (this.search.value) {
        params[this.search.key] = this.search.value
      }

      findAccAuthorityDevice(params).then(data => {
        if (data.code === '00000000') {
          this.doorList = data.payload.results
        } else {
          this.errorMessage(data.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.acc-auth-cla {
  display: flex;
  min-height: 600px;
  .left-part-cla {
    width: 400px;
    padding: 10px;
    border: 1px solid gray;
  }
  .right-part-cla {
    margin-left: 20px;
    flex-grow: 1;
    border: 1px solid gray;
    padding: 10px;
  }
  .time-bar {
    background-color: gray;
    height: 10px;
    flex-grow: 1;
    position: relative;
    border-radius: 10px;
  }
  .active-time-bar {
    background-color: #4db22f;
    height: 10px;
    border-radius: 10px;
    position: absolute;
    top: 0px;
    text-align: center;
  }

  .time-bar-box {
    display: flex;
    padding: 0px 10px;
    height: 60px;
    align-items: center;
  }
  .time-bar-label {
    width: 100px;
    display: inline-block;
    text-align: center;
  }
  .start-tip {
    position: absolute;
    left: 0px;
    top: -20px;
  }
  .end-tip {
    position: absolute;
    right: 0px;
    top: -20px;
  }
  .active-time-tip {
    position: relative;
    top: 10px;
  }
  .collapse-title {
    font-size: 20px;
    padding-left: 60px;
  }
  /deep/ .el-collapse-item__arrow {
    position: absolute;
    left: 20px;
  }
  /deep/.el-collapse-item__header {
    position: relative;
  }
}

.doorDevice-online-cla {
  color: @themeColor;
}
.doorDevice-offline-cla {
  color: @ststusFailed;
}

.door-table-cla {
  /deep/ .el-table__row {
    cursor: pointer;
  }
}

.enpty-info-cla{
    margin-top:40px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/companyInfo/employeeDetail/accAuth.vue